import React from 'react';
import { Spin } from 'antd';
import { Row, Col, Select, SelectOption } from 'components/ui';
import { useFetchExperimentationFeatures } from 'query/ab-test';
import { useFormContext, Controller } from 'react-hook-form';

const SelectExperiment = () => {
  const { control } = useFormContext();

  const {
    data: features,
    isLoading: loadingFeatures,
  } = useFetchExperimentationFeatures();

  return (
    <section className="send-mail-form__section">
      <Row gutter={8}>
        <Col span={22}>
          <Spin size="small" spinning={loadingFeatures}>
            <h5>GrowthBook Feature *</h5>
          </Spin>
          <Controller
            control={control}
            name="growthBookFeatureName"
            render={({
              field: { value, onChange, onBlur },
              fieldState: { error },
            }) => {
              return (
                <Select
                  className="select-template__btn"
                  error={!!error}
                  helperTxt={error?.message}
                  optionFilterProp="children"
                  showSearch
                  value={value}
                  onBlur={onBlur}
                  onChange={onChange}
                >
                  <SelectOption key="default" value={''}>
                    Select Feature
                  </SelectOption>
                  {features.map(feature => (
                    <SelectOption
                      key={feature.features}
                      value={feature.feature}
                    >
                      {feature.displayName}
                    </SelectOption>
                  ))}
                </Select>
              );
            }}
          />
        </Col>
      </Row>
    </section>
  );
};

export default SelectExperiment;
